var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mapId)?_c('div',{staticClass:"map-element",style:({ height: `${_vm.element.height}px` }),attrs:{"id":_vm.mapId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }